import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Margin, Text } from 'shared/components'
import Toggle from 'react-toggle'

import * as styles from './styles'

const renderIcon = (iconName) =>
  iconName ? <Text as={FontAwesomeIcon} size={10} icon={iconName} /> : null

const ToggleComponent = ({
  id,
  checkedLabel,
  uncheckedLabel,
  value,
  onInternalChange,
  disabled,
  checkedIcon,
  uncheckedIcon,
}) => (
  <div>
    <Margin
      as={Toggle}
      id={id}
      right={1}
      disabled={disabled}
      checked={value}
      onChange={onInternalChange}
      icons={{
        checked: renderIcon(checkedIcon),
        unchecked: renderIcon(uncheckedIcon),
      }}
    />
    <span css={styles.label} htmlFor={id}>
      {value ? checkedLabel : uncheckedLabel}
    </span>
  </div>
)

ToggleComponent.propTypes = {
  id: PropTypes.string,
  value: PropTypes.bool,
  checkedLabel: PropTypes.string,
  uncheckedLabel: PropTypes.string,
  onInternalChange: PropTypes.func,
  disabled: PropTypes.bool,
  checkedIcon: PropTypes.string,
  uncheckedIcon: PropTypes.string,
}

export default ToggleComponent
